module.exports = __webpack_public_path__ + "static/condo-1-a05561854267d7852f51a90793bab2ca.jpg";